import axios from 'axios';

const token = localStorage.getItem('accessToken');

const apiSales = axios.create({
    baseURL: process.env.VUE_APP_SALES_API,
    headers: { 'Authorization': `bearer ${token}`, 'X-Client-Identifier': "DneSales" }
});

export default apiSales;